import { render, staticRenderFns } from "./PersistCompartilhamentoAppView.vue?vue&type=template&id=2e247d6b&"
import script from "./PersistCompartilhamentoAppView.vue?vue&type=script&lang=ts&"
export * from "./PersistCompartilhamentoAppView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports